import { useContactsInitContactDialogMutation } from '../api/repositories/use-contacts-init-contact-dialog.mutation';
import { InitContactDialogInput } from 'api-new/generated';
import { ConfirmationModal } from 'components/confirm-modal';
import { ToggleState } from 'hooks/use-toggle';
import { FC } from 'react';

type Props = {
  state: ToggleState<InitContactDialogInput>;
  onDialogCreated?: (contactId: number) => void;
};

const ConfirmCreateDialogModal: FC<Props> = ({ state, onDialogCreated }) => {
  const { mutate: initContactDialog, isLoading: isLoadingInitContactDialog } = useContactsInitContactDialogMutation();

  const handleConfirm = () => {
    initContactDialog(
      {
        requestBody: state.data
      },
      {
        onSuccess(response) {
          if (onDialogCreated) onDialogCreated(response);
          state.close();
        }
      }
    );
  };

  const handleCancel = () => {
    state.close();
  };

  return (
    <ConfirmationModal
      title="Confirm to create"
      message="There is no any communication yet. Do you want to create a new one and join as a participant?"
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      isSubmitting={isLoadingInitContactDialog}
    />
  );
};

export default ConfirmCreateDialogModal;
